import { render, staticRenderFns } from "./LangIcon.vue?vue&type=template&id=6fc23bb7&"
import script from "./LangIcon.vue?vue&type=script&lang=js&"
export * from "./LangIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports